export const COMPONENT_PAGE_COPY = {
  breadcrumbLabel: 'Breadcrumb',
  backToList: 'Back to the list',
  discard: 'Discard',
  save: 'Save changes',
  saving: 'Saving…',
  delete: 'Delete',
  deleteTitle: (componentName: string) => `Delete "${componentName}"?`,
  deleteBlockedBody: (componentName: string) =>
    `${componentName} is still used by an agent template. Remove it from the template and sync before deleting it.`,
  deleteUsageCheckFailedBody: (componentName: string) =>
    `We couldn't check whether a template still uses ${componentName}. Refresh the page to try again.`,
  detailsHeading: 'Details',
  nameHelp: 'What you and your team call it. Tenants see the tenant display name instead.',
  descriptionLabel: 'Description',
  descriptionHelp: 'A short note for your team about what it is for. Never sent to the agent.',
  agentHeading: 'Sent to the agent',
  agentDescription: 'Tenants never see this section.',
  triggerLabel: 'When to run',
  triggerHelp: 'The situation that should trigger this skill.',
  instructionsLabel: 'Instructions',
  tenantHeading: 'Tenant display',
  tenantDescription: 'What tenants see in onboarding and settings. Never sent to the agent.',
  tenantNameLabel: 'Tenant display name',
  tenantNameHelp: 'The name tenants see. Required when visible.',
  tenantDescriptionLabel: 'Tenant description',
  tenantDescriptionHelp:
    'One plain sentence about what it means in a conversation. Required when visible.',
  tenantHiddenNoticeStart: "Hidden from tenants, so these fields aren't used. Change ",
  tenantHiddenNoticeEnd: ' to show it.',
  usedInHeading: 'Used in',
  usedInNone: 'No template uses this component yet.',
  modeLegend: 'Visibility & control',
  escalationModeNote:
    "Escalations send calls to the tenant's transfer number, so tenants always see them.",
  characterCount: (characterCount: number, maxLength: number) => `${characterCount} / ${maxLength}`,
} as const;

export const TENANT_PREVIEW_COPY = {
  heading: 'Tenant preview',
  description: 'How this looks in onboarding and settings when visible to tenants.',
  hidden: "Hidden. Tenants won't see this item.",
  setBy: (partnerName: string) => `Set by ${partnerName}`,
  switchedOn: 'Switched on',
  switchedOff: 'Switched off',
} as const;

export const TOOLS_FIELD_COPY = {
  legend: 'Tools',
  help: 'API calls the agent can make. Tools can be shared across skills and guidance.',
  addTool: 'Add tool',
  noTools: 'No tools added.',
  loading: 'Loading tools…',
  lookupTool: 'Synced schema lookup',
  inactiveTool: 'Inactive tool',
  inactiveToolDescription: "Agents can't use this tool until it is active again.",
  removeLabel: (toolName: string) => `Remove ${toolName}`,
} as const;

export const SAVE_COPY = {
  saved: 'Saved',
  savedDetail: 'Changes to this component reach your tenants once you sync any templates that use it.',
  saveFailed: 'Could not save',
  deleted: 'Deleted',
  deleteFailed: 'Could not delete',
} as const;
